import { render, staticRenderFns } from "./transactions-statistics.vue?vue&type=template&id=c7bc4074&"
import script from "./transactions-statistics.vue?vue&type=script&lang=js&"
export * from "./transactions-statistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports